<ul *ngIf="breadcrumbs">
  <li
    *ngFor="let breadcrumb of customBreadcrumbs || breadcrumbs; let i = index"
  >
    <a
      class="rv-pointer"
      *ngIf="breadcrumb.url"
      [routerLink]="breadcrumb.url"
      [phi]="!!breadcrumb.phi"
      >{{ breadcrumb.title }}</a
    >
    <a
      class="rv-pointer"
      *ngIf="!breadcrumb.url"
      (click)="customBreadcrumbClick.emit(i)"
      [phi]="!!breadcrumb.phi"
      >{{ breadcrumb.title }}</a
    >
  </li>
</ul>
